import { IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, IsDate ,IsEnum} from "class-validator";
import { ApiOAuth2, ApiProperty } from "@nestjs/swagger";
import { NotificationStatus } from "@gtpl/shared-models/common-models";

export class NotificationDTO{

    @ApiProperty()
    @IsNotEmpty({message: 'Notification Id should not be empty'})
    @IsAlphanumeric()
    @IsOptional()
    notificationId: number;

    @ApiProperty()
    @IsNotEmpty({message: 'Plant Id should not be empty'})
    plantId: number;   

    @ApiProperty()
    @IsNotEmpty({message: 'Plant should not be empty'})
    plant: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Job Description should not be empty'})
    jobRole: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Job Description should not be empty'})
    jobDescription: string;

    @ApiProperty()
    @IsDate()
    notificationDate: Date;

    @ApiProperty()
    @IsNotEmpty({message: 'Resource should not be empty'})
    resourceRequired: string;

    @ApiProperty()
    @IsNotEmpty({message: 'skills should not be empty'})
    skills: string;

    @ApiProperty()
    @IsNotEmpty({message: 'Experience should not be empty'})
    yearOfExperience: string;

    @ApiProperty()
    @IsDate()
    plannedClosingDate: Date;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    status: NotificationStatus;

    @ApiProperty()
    isActive: boolean;

    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Created User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Created User should be only alphabets"})
    createdUser: string;

    updatedAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), {message: "Updated User should be only alphabets"})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    
     
    @ApiProperty()
    viewData: any;

}